import React, { useCallback, useEffect } from 'react';
import useForm, { buildInput } from '@ui/forms/use-form';
import FormHtmlInput from '@ui/forms/form-input';
import WhenTrue from "@ui/when/when-true";

const FormEmployment = ({ data, initValues, onFormStateChanged, validateMonth}) => {

    const { employmentType, years, months } = data; 

    const introText = data.introText;   

    const UnemployedValue = "unemployed";

    const form = useForm({
        inputs: [        
            buildInput(employmentType, initValues.employmentType),
            buildInput(years, initValues.years),
            buildInput(months, initValues.months, [
                {
                    name: "month-years",
                    message: months.requiredError,
                    check: useCallback(validateMonth),
                },
            ]),
        ],
        onSubmit: () => {},
    });

    const isUnemployed = useCallback(
        () => form.values.employmentType === UnemployedValue
    );
        
    useEffect(() => {
        if (onFormStateChanged) {
            onFormStateChanged(form);
        }
    }, [form.isValid, form.values]);

    return (
        <div>            
            <div className="flex flex-col gap-6">                                                
                <FormHtmlInput autoFocus={true} data={employmentType} form={form} />
                <WhenTrue condition={!isUnemployed()}>
                    <FormHtmlInput data={years} form={form} />
                    <FormHtmlInput data={months} form={form} />                    
                </WhenTrue>
            </div>
        </div>
    );
};

export default FormEmployment;